import { PARTNER_ONBOARDING_STATUSES, PartnerOnboardingStageCounts, PartnerOnboardingStatus } from 'vopay';

/**
 * The stages the summary's pills show, and the Status filter offers — the same list in the same order
 * (ID-14136, as ID-13964 did for the Accounts page): the partner's pipeline stages, zero included, then
 * any other onboarding status that holds entities. Without counts yet, the pipeline alone.
 */
export default function getVisibleOnboardingStages(
  pipelineStages: PartnerOnboardingStatus[],
  stageCounts: PartnerOnboardingStageCounts | undefined,
): PartnerOnboardingStatus[] {
  const otherPopulated = stageCounts
    ? PARTNER_ONBOARDING_STATUSES.filter((status) => !pipelineStages.includes(status) && stageCounts[status] > 0)
    : [];

  return [...pipelineStages, ...otherPopulated];
}
